var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36694 15.8004C2.03687 14.4703 2.03687 12.308 3.36694 10.9779L6.47821 7.86666L5.00036 6.3888L1.88909 9.50007C-0.257689 11.6468 -0.257689 15.1315 1.88909 17.2782C4.03586 19.425 7.52049 19.425 9.66726 17.2782L12.7785 14.167L11.3007 12.6891L8.18941 15.8004C6.85934 17.1305 4.69701 17.1305 3.36694 15.8004ZM7.33381 13.3892L13.5563 7.16662L12.0007 5.61099L5.77817 11.8335L7.33381 13.3892ZM9.66726 1.7219L6.55599 4.83317L8.03385 6.31102L11.1451 3.19975C12.4752 1.86968 14.6375 1.86968 15.9676 3.19975C17.2977 4.52982 17.2977 6.69215 15.9676 8.02222L12.8563 11.1335L14.3342 12.6113L17.4454 9.50007C19.5922 7.3533 19.5922 3.86867 17.4454 1.7219C15.2987 -0.424878 11.814 -0.424879 9.66726 1.7219Z",
    fill: "#391D69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.da49b9ad5cc1ff038470c74d432ce20a.svg";
export { ForwardRef as ReactComponent };